import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "./components/ui/sonner";
import { Navbar } from "./components/trace/Navbar";
import { Footer } from "./components/trace/Footer";
import Home from "./pages/Home";
import Scanner from "./pages/Scanner";
import Developers from "./pages/Developers";

const ScrollTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="flex min-h-screen flex-col bg-trace-bg">
      <BrowserRouter>
        <ScrollTop />
        <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded focus:bg-trace-green focus:px-3 focus:py-2 focus:text-trace-bg">
          Skip to content
        </a>
        <Navbar />
        <div id="main" className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/scan" element={<Scanner />} />
            <Route path="/scan/:address" element={<Scanner />} />
            <Route path="/developers" element={<Developers />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
